import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
//import axios from "axios";
import { useSucursal } from '../../contexts/SucursalContext';
import NavbarUni from './componentes/headUni';
import FooterPublic from './FooterPublic';
//import ModalAuto from './componentes/ModalAuto';
//import { API } from '../../api/URL_API';
import Marquee from './componentes/marquee';
import './styles/HomePage.css';
import Loader from './ventaUnidad/componenetes/Loader';
import BodyUni from './componentes/bodyUni';
import BannerHome from './componentes/bannerHome';
import ModalAuto from './componentes/ModalAuto';

function HomePage() {
    const { idSucursal: urlIdSucursal } = useParams();
    const { idSucursal, loading, setIdSucursal } = useSucursal();

    // ===============================
    // Manejo sucursal
    // ===============================
    useEffect(() => {
        if (urlIdSucursal && urlIdSucursal !== idSucursal) {
            setIdSucursal(urlIdSucursal);
            localStorage.setItem('idSucursal', urlIdSucursal);
        } else if (!idSucursal) {
            const stored = localStorage.getItem('idSucursal');
            if (stored) setIdSucursal(stored);
        }
    }, [urlIdSucursal, idSucursal, setIdSucursal]);

    return (
        <div className="bg-light">
            {loading && <Loader />}
            <ModalAuto />
            <Marquee />
            <NavbarUni />
            <BannerHome idSucursal={idSucursal} />
            <BodyUni />
            <FooterPublic idSucursal={idSucursal} />
        </div>
    );
}

export default HomePage;
